import {FC} from 'react'

interface Props {
  text?: any
}

const Header: FC<Props> = ({text}) => {
  return (
    <div>
      <p>
        Documento: <span>{text.toUpperCase()}</span>
      </p>
    </div>
  )
}

export {Header}
